<template>
  <b-modal
    id="final-hold"
    size="md"
    centered
    hide-footer
    hide-header
    class="p-0"
    no-close-on-backdrop
    @hidden="closeFinalHold"
  >
    <div class="modalheading d-flex align-items-center justify-content-between">
      <span class="caution-txt">Move to On-Hold</span>
    </div>
    <hr />
    <div class="xMarkCancel" @click="closeFinalHold">
      <img src="../../../assets/cross-round.svg" alt="" />
    </div>
    <div class="final-select-modal-text-jd">
      Are you sure you want to move this candidate to On-Hold?
    </div>

    <div class="d-flex align-items-center justify-content-end mt-4">
      <b-button class="addbtn" @click="directOnHold()"> Confirm </b-button>
    </div>
  </b-modal>
</template>
<script>
import { directOnHold } from "../../../controllers/JD/asynchronous.js";
export default {
  name: "FinalOnHold",
  props: {
    context: Object,
  },

  methods: {
    async directOnHold() {
      await directOnHold(this.context);
    },
    closeFinalHold() {
      this.$bvModal.hide("final-hold");
    },
  },
};
</script>
